import store from "@/store";
import { ROLES } from "@/config/permissions";

function isSuperAdmin(to, from, next) {
  const user = store.state.users?.user || store.getters["users/currentUser"];
  const role = store.state.users?.role;

  if (!user) {
    return next({ path: "/login", replace: true });
  }

  if (role === ROLES.SYSTEMADMINS || (user.role && user.role.id == 1)) {
    return next();
  }

  return next({ path: "/403", replace: true });
}

export default isSuperAdmin;
